import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TicketHistoryState as State, TICKET_HISTORY_FEATURE_KEY } from './ticket-history.reducer';

export const ticketHistoryNgrxState = createFeatureSelector<State>(TICKET_HISTORY_FEATURE_KEY);

export const getTicketHistoryFilter = createSelector(ticketHistoryNgrxState, (state: State) => state.filter);
